import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22inter.ts%22,%22import%22:%22Inter%22,%22arguments%22:[{%22display%22:%22swap%22,%22fallback%22:[%22system-ui%22,%22-apple-system%22,%22Roboto%22,%22Helvetica%22,%22Arial%22,%22sans-serif%22],%22subsets%22:[%22latin%22],%22variable%22:%22--font-inter%22}],%22variableName%22:%22inter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Inter', system-ui, -apple-system, Roboto, Helvetica, Arial, sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
